import { Stack, Typography } from "@mui/material";
import { ContentCard } from "@shared";

import { DataTable } from "@/common/components/table/DataTable";
import { useTranslation } from "@/translations";

import { useVolunteerAssignedClients } from "./hooks/useVolunteerAssignedClients";

export function VolunteerAssignedClients() {
  const { t } = useTranslation();
  const { rows, isLoading, columns, openClient } = useVolunteerAssignedClients();

  return (
    <ContentCard title={t("volunteers.assignedClients.title")}>
      <Typography variant="body2" color="text.secondary">
        {t("volunteers.assignedClients.description")}
      </Typography>
      {rows.length === 0 && !isLoading ? (
        <Typography>{t("volunteers.assignedClients.empty")}</Typography>
      ) : (
        <Stack sx={{ overflow: "auto", flex: 1, minHeight: 0 }}>
          <DataTable
            data={rows}
            columns={columns}
            getRowId={(row) => row.clientId}
            onRowClick={openClient}
            rowHeight={48}
            initialSortModel={[{ field: "clientName", sort: "asc" }]}
          />
        </Stack>
      )}
    </ContentCard>
  );
}
